import { Outlet } from "react-router-dom";
import Navbar from "../components/Header/Navbar";
import Footer from "../components/Header/Footer";
import SignInModel from "../pages/Login/SignInModel";
import { useSelector } from "react-redux";
import useSessionMonitor from "../hooks/useSessionMonitor";
import GlobalAuthLoader from "../components/Login/GlobalAuthLoader";
import ScrollToTop from "../components/Common/ScrollToTop";

const Root = () => {
  const { isSignInModalOpen } = useSelector((state) => state.auth);

   // Initialize the session monitor
   useSessionMonitor();

  return (
    <div className="flex flex-col min-h-screen min-w-[320px]">
      <GlobalAuthLoader /> 
      <div className="mt-6">
        <Navbar />
      </div>
      <main className="flex-grow pt-[70px] w-full max-w-[1600px] mx-auto">
        {/* Handle Sign In Modal */}
        <SignInModel isOpen={isSignInModalOpen}/>
        <ScrollToTop />
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Root;
